{
  "audit_trail": {
    "button": {
      "text": "Audit Trail"
    },
    "modal": {
      "header": "Audit Trail"
    },
    "loading": {
      "aria_label": "loading audit trails"
    },
    "table": {
      "current": "Current"
    },
    "details": {
      "show_details_aria_label": "show details"
    }
  }
}
